import { render, staticRenderFns } from "./search-destination-selector.vue?vue&type=template&id=f674bef2"
import script from "./search-destination-selector.vue?vue&type=script&lang=js"
export * from "./search-destination-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports